import api from './api.js';
class Orders {
    constructor(){
        this.url_orders = 'Orders'
    }
    get(data){
        return api.get(`${this.url_orders}/${data.id}`);
    }
    mostRecent(){
        return api.get(`${this.url_orders}/MostRecent`)
    }
    all(){
      return api.get(this.url_orders);
    }
    getDataSource(id){
        return api.getDataSource(this.url_orders, id);
    }
    getWorksheetOrdersDataSource(id){
        return api.getDataSource(`${this.url_orders}/worksheet`, id);
    }
    filtered(id, data){
        return api.postDataSource(`${this.url_orders}/Search`, id, data);
    }
    create(data){
        return api.post(this.url_orders, data);
    }
    update(data){
        return api.put(`${this.url_orders}`, data);
    }
    clone(data){
        return api.put(`${this.url_orders}/Clone`, data);
    }
    delete(data){
        return api.delete(`${this.url_orders}/${data.id}`);
    }
    undelete(data){
        return api.put(`${this.url_orders}/${data.id}/Undelete`);
    }
    commit(data){
        return api.post(`${this.url_orders}/Commit`, data);
    }
    uncommit(data){
        return api.put(`${this.url_orders}/${data}/Uncommit`, data);
    }
    submitOrderLink(data){
        return api.put(`${this.url_orders}/${data}/OrderLink`, data);
    }
    deleteMultiple(data){
        return api.post(`${this.url_orders}/Delete`, data);
    }
    updateStatus(data){
        return api.put(`${this.url_orders}/${data.Id}/Status`, data);
    }
    refreshPricing(data){
        return api.put(`${this.url_orders}/RefreshOrderLinePricing`, data)
    }
    import(data){
        let headers = { 'Content-Type': 'multipart/form-data'};
        let formData = new FormData();
        console.log('file',data.file);
        formData.append('file',data.file, data.file.name);
        // formData.append('printOption',data.printOption);
        // formData.append('removeZeroCostRetail',data.removeZeroCostRetail);
        console.log('formdata',formData);
        // return api.post(`${this.url_orders}/Import`, formData, headers);
        return api.post(`${this.url_orders}/Import?printOption=${data.printOption}&removeZeroCostRetail=${data.removeZeroCostRetail}&importQuotePricing=${data.importQuotePricing}`, formData, headers);
    }
    saveWorksheetName(data){
        return api.put(`${this.url_orders}/Name`, data)
    }
    getVersionHistory(orderId){
        return api.get(`${this.url_orders}/${orderId}/Versions`)
    }
    getAtPointInTime(orderId, asOfTime){
        return api.get(`${this.url_orders}/${orderId}/AtTime?asOfTime=${encodeURIComponent(asOfTime)}`)
    }
    getAtVersion(orderId, versionNumber){
        return api.get(`${this.url_orders}/${orderId}/AtVersion?versionNumber=${versionNumber}`)
    }
}

export default new Orders
